if (!customElements.get("madara-ugc")) {
    customElements.define(
        "madara-ugc",
        class MadaraUGC extends HTMLElement {
            constructor() {
                super();

                this.isScrolling = false;
                this.isClickAction = false;

                this.carousel = this.querySelector(".madara-carousel__wrapper");
                this.items = this.querySelectorAll("madara-ugc .ugc-card");

                this.initClickHandlers();
                this.initScrollEndHandler();
                // this.initMuteHandlers();
                this.playFirstVideo();
            }

            initScrollEndHandler() {
                const carouselWidth = this.carousel.scrollWidth;
                const containerWidth = this.carousel.clientWidth;

                if (carouselWidth > containerWidth) {
                    let scrollTimeout;
                    this.carousel.addEventListener("scroll", (e) => {
                        clearTimeout(scrollTimeout);
                        scrollTimeout = setTimeout(() => {
                            // Only proceed if this wasn't triggered by a click
                            if (!this.isClickAction) {
                                let maxVisibility = 0;
                                let mostVisibleItem = null;
                                
                                this.items.forEach(item => {
                                    const rect = item.getBoundingClientRect();
                                    const containerRect = e.target.getBoundingClientRect();
                                    
                                    const visibleWidth = Math.min(rect.right, containerRect.right) - Math.max(rect.left, containerRect.left);
                                    const visibility = visibleWidth / rect.width;
                                    
                                    if (visibility > maxVisibility) {
                                        maxVisibility = visibility;
                                        mostVisibleItem = item;
                                    }
                                });

                                if (mostVisibleItem) {
                                    this.scrollToCenter(mostVisibleItem);
                                }
                            }
                            this.isClickAction = false;
                        }, 100); // 100ms delay after scrolling stops
                    });
                }
            }

            initClickHandlers() {
                this.items.forEach((item) => {
                    // Add click handler to both the card and the poster button
                    const handleClick = () => {
                        this.isClickAction = true;
                        this.scrollToCenter(item);
                    };

                    item.addEventListener("click", () => handleClick());
                    item.querySelector(".media__poster")?.addEventListener("click", (e) => {
                        handleClick(e);
                    });
                });
            }

            // TODO: Add mute handlers
            //   initMuteHandlers() {
            //     this.items.forEach((item) => {
            //       const muteButton = item.querySelector(".ugc-card__mute-button");

            //       if (muteButton) {
            //         muteButton.addEventListener("click", (e) => {
            //           console.log("muteButton", muteButton);
            //           e.stopPropagation(); // Prevent card click handler from firing
            //           const video = item.querySelector("video");

            //           if (video.hasAttribute("muted")) {
            //             video.removeAttribute("muted");
            //             video.muted = false;
            //             muteButton.textContent = "Unmute";
            //           } else {
            //             video.setAttribute("muted", "muted");
            //             video.muted = true;
            //             muteButton.textContent = "Mute";
            //           }
            //         });
            //       }
            //     });
            //   }

            scrollToCenter(item) {
                // Reset all item states
                this.items.forEach((carouselItem) => {
                    carouselItem.querySelector("video")?.pause();
                    carouselItem.classList.remove("ugc-card__is-active");
                });

                // Set acitve item
                item.classList.add("ugc-card__is-active");
                item?.querySelector(".media__poster")?.click();

                // Scroll item to center
                const containerWidth = this.carousel.offsetWidth;
                const itemWidth = item.offsetWidth;
                const itemLeft = item.offsetLeft;
                const scrollLeft = itemLeft - (containerWidth - itemWidth) / 2;

                this.carousel.scrollTo({ left: scrollLeft, behavior: "smooth" });
            }

            playFirstVideo() {
                this.items?.[0]?.querySelector(".media__poster")?.click();
                this.isClickAction = false;
            }
        }
    );
}
